import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	root: {
		width: '100%',
	},
	stepper:{
		backgroundColor: 'white',
		marginBottom: '10px'
	},
	rootButton:{
		textAlign: 'center',
		padding: '20px'
	},
	button: {
		marginRight: theme.spacing(1),
	},
	instructions: {
		marginTop: theme.spacing(1),
		marginBottom: theme.spacing(1),
	},
	Margenes:{
		marginLeft:'10%',
		marginRight: '10%',
	},
  }));
